/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import CedulaTaggingContainer from './container/CedulaTaggingContainer';

function RequirementsTaggingContainer({ match }) {
  return (
    <div className="module-inner">
      <div className="module-inner-title">Requirements Tagging</div>
      <div className="generic-module-nav mb-3">
        <NavLink
          exact
          className="nav-link"
          activeClassName="active"
          to="/requirements-tagging"
        >
          Cedula
        </NavLink>
        {/* <NavLink
          exact={false}
          className="nav-link"
          activeClassName="active"
          to="/equirements-tagging/individual"
        >
          Individual
        </NavLink>
        <NavLink
          exact={false}
          className="nav-link"
          activeClassName="active"
          to="/equirements-tagging/corporation"
        >
          Corporation
        </NavLink> */}
      </div>
      <Switch>
        <Route exact path={`${match.path}`} component={CedulaTaggingContainer} />
        {/* <Route
          path={`${match.path}/individual`}
          component={IndividualContainer}
        />
        <Route
          path={`${match.path}/corporation`}
          component={CorporationContainer}
        />
        <Route
          path={`${match.path}/settings`}
          component={CdlSettingsContainer}
        /> */}
      </Switch>
    </div>
  );
}

RequirementsTaggingContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(RequirementsTaggingContainer);
